import { useMemo } from 'react';
import { useQuery, gql } from '@apollo/client';
import { defaultPropTypes } from '../utils';
import ChoiceField from './ChoiceField';

const GET_CUSTOM_ALARM_IDS_AND_NAMES = gql`
    {
        customAlarms {
            edges {
                node {
                    pk
                    name
                }
            }
        }
    }
`;

export function SelfDefinedAlarmLineField({ fieldOptions }) {
    const { data } = useQuery(GET_CUSTOM_ALARM_IDS_AND_NAMES, {
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
    });

    const extraChoiceOptions = useMemo(() => {
        const nodes = data?.customAlarms?.edges?.map((edge) => edge?.node) ?? [];
        return nodes.map(({ pk, name }) => [pk, name]);
    }, [data]);

    return (
        <ChoiceField
            fieldOptions={fieldOptions}
            extraChoiceOptions={extraChoiceOptions}
            addOptionWhenMissing={true}
        />
    );
}

SelfDefinedAlarmLineField.propTypes = defaultPropTypes;
